export const WORKFLOW_STATES = {
  DRAFT: 'draft',
  LIVE: 'live',
  PAUSED: 'paused',
  DISABLED: 'disabled',
}
